import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { FaEnvelope, FaPhone, FaWhatsapp } from "react-icons/fa";
import "../App.css";

const About = () => {
  const director = {
    name: "Mfundiso Ndlebe",
    role: "Managing Director",
    email: "admin@ndlebeattorneys.co.za",
    phone: "+27 83 303 0262",
    whatsapp: "+27833030262",
    quote: "Justice delayed is justice denied. We fight for your rights."
  };

  return (
    <section id="about" className="about-section py-5">
      <Container>

        <Row className="g-4 align-items-stretch">

          {/* LEFT - ABOUT US */}
          <Col lg={6}>
            <div className="about-card h-100">

              <h2 className="fw-bold mb-4 about-title">
                ABOUT US
              </h2>

              <p className="about-text">
                At <strong>Ndlebe Msuthu Inc Attorneys</strong>, we are dedicated to providing
                exceptional legal services with integrity, expertise, and a client-focused approach.
                Our vision is to be a leading law firm in South Africa.
              </p>

              <p className="about-text">
                Our team brings deep expertise across multiple legal disciplines,
                ensuring tailored guidance and strategic solutions for every client.
              </p>

              <p className="about-text mb-0">
                Whether business, personal, or dispute matters —
                <strong> Ndlebe Msuthu Inc Attorneys</strong> is your trusted legal partner.
              </p>

            </div>
          </Col>

          {/* RIGHT COLUMN (STACKED) */}
          <Col lg={6} className="d-flex flex-column gap-4">

            {/* TOP - QUOTE */}
            <div className="quote-card text-center d-flex align-items-center justify-content-center h-50">
              <blockquote className="m-0">
                <p className="fst-italic quote-text">
                  "{director.quote}"
                </p>
              </blockquote>
            </div>

            {/* BOTTOM - BUSINESS CARD */}
            <Card className="director-card shadow-sm">
                <Row className="g-0 align-items-center text-center text-md-start">

                    {/* IMAGE */}
                    <Col xs={12} md={4} className="p-3 d-flex justify-content-center">
                    <Image
                        src="/Mfundiso.jpeg"
                        alt={director.name}
                        roundedCircle
                        fluid
                        className="director-img"
                    />
                    </Col>


                    <Col xs={12} md={8} className="p-3">

                    <h6 className="text-uppercase fw-bold text-secondary">
                        {director.role}
                    </h6>

                    <h5 className="fw-bold director-name">
                        {director.name}
                    </h5>

                    {/* <p className="mb-1">
                        <FaEnvelope className="me-2 icon" />
                        <a href={`mailto:${director.email}`}>{director.email}</a>
                    </p>

                    <p className="mb-1">
                        <FaPhone className="me-2 icon" />
                        <a href={`tel:${director.phone}`}>{director.phone}</a>
                    </p>

                    <p className="mb-0">
                        <FaWhatsapp className="me-2 icon" />
                        <a
                        href={`https://wa.me/${director.whatsapp.replace(/\D/g, "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        Chat on WhatsApp
                        </a>
                    </p> */  }

                    </Col>

                </Row>
            </Card>

          </Col>

        </Row>

      </Container>
    </section>
  );
};

export default About;